const fr_fr = {};

export default fr_fr;
